export function summaryAvailability(data) {
  if (!data || data.source === 'youtube' || data.result_state === 'empty') return 'not_applicable';
  const review = data.speaker_postprocessing || data.full?.diarization?.high_quality_speaker_annotation;
  const summary = data.transcript_summary || review?.transcript_summary;
  if (typeof summary?.summary === 'string' && summary.summary.trim()) return 'ready';
  if (review?.status === 'processing') return 'pending';
  if (review?.status === 'llm_failed') return 'failed';
  // Skipped reviews, publisher captions and historical transcripts without a
  // review are expected to have no summary. Only missing applied output is an error.
  return review?.status === 'applied' ? 'missing' : 'not_applicable';
}

export function showsSummaryTab(data, activeTab) {
  const state = summaryAvailability(data);
  return ['ready', 'pending', 'failed'].includes(state) || (state === 'missing' && activeTab === 'summary');
}
